import { Component } from "react";
import i18next from "i18next";

const containerStyle = {
  minHeight: "100vh",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 24,
  padding: 16,
  textAlign: "center",
  color: "#293041",
  backgroundColor: "#FBFCFC",
};

const buttonStyle = {
  minHeight: 44,
  padding: "0 24px",
  border: "none",
  borderRadius: 8,
  backgroundColor: "#1655B9",
  color: "#FFFFFF",
  fontSize: 16,
  cursor: "pointer",
};

// Last-resort screen for render errors, so a crash never leaves the user with a blank page.
// Deliberately has no router or store dependency, so it keeps working when those are what failed.
class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Unhandled render error", error, errorInfo?.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    const dir = i18next.dir();
    return (
      <div role="alert" dir={dir} style={containerStyle}>
        <p style={{ margin: 0, fontSize: 18 }}>{i18next.t("common:app_error")}</p>
        <button type="button" style={buttonStyle} onClick={() => window.location.reload()}>
          {i18next.t("common:reload")}
        </button>
      </div>
    );
  }
}

export default ErrorBoundary;
